import { Card, CardBody } from '@/shared/ui/Card';
import { Icon } from '@/shared/ui/Icon';

/**
 * Tela de modulo ainda nao implementado.
 *
 * A pagina diz exatamente o que existe e o que nao existe. Uma tela com dados
 * fabricados aparentaria um sistema pronto e levaria alguem a tomar decisao sobre
 * numero que nao veio de lugar nenhum.
 */
export function ModulePlaceholder({
  title,
  phase,
  description,
}: {
  title: string;
  phase: number;
  description?: string;
}) {
  return (
    <Card>
      <CardBody className="flex flex-col items-center gap-4 py-16 text-center">
        <span className="flex size-14 items-center justify-center rounded-full bg-brand-50 text-brand-500">
          <Icon name="sparkle" size={26} />
        </span>

        <div className="max-w-md">
          <h2 className="text-base font-semibold text-ink-900">{title}</h2>
          <p className="mt-2 text-sm leading-relaxed text-ink-500">
            {description ??
              'Este modulo esta modelado e documentado, e a implementacao entra na fase indicada abaixo.'}
          </p>
        </div>

        <p className="rounded-full bg-ink-100 px-3 py-1 text-xs font-medium text-ink-600">
          Previsto para a fase {phase}
        </p>

        <p className="max-w-sm text-2xs text-ink-400">
          O roteiro completo de entrega esta em docs/MODULES.md.
        </p>
      </CardBody>
    </Card>
  );
}
